import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport } from "vue";
const _hoisted_1 = { class: "license-plate-overlay__group" };
const _hoisted_2 = { class: "license-plate-overlay__header" };
const _hoisted_3 = { class: "license-plate-overlay__logo" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "license-plate-overlay__content" };
const _hoisted_6 = {
    key: 0,
    class: "license-plate-overlay__group license-plate-overlay__group--blue"
};
const _hoisted_7 = {
    key: 0,
    class: "license-plate-overlay__loading"
};
const _hoisted_8 = { class: "loading-text" };
const _hoisted_9 = {
    key: 0,
    class: "license-plate-overlay__vehicles"
};
const _hoisted_10 = { class: "license-plate-overlay__vehicles-list" };
import { ref, computed, nextTick, watch } from 'vue';
import NumberPlateInput from './NumberPlateInput.vue';
import VehicleCard from './VehicleCard.vue';
import { useAssets } from '../../composables/useAssets';
import { useVehicleDetails } from '../../composables/useVehicleDetails';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LicensePlateEditOverlay',
    emits: ["close", "vehicleSelected"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const { assetUrl } = useAssets();
        const { vehicleDetails, setVehicleDetails, setLicencePlate } = useVehicleDetails();
        const containerRef = ref(null);
        const isVisible = ref(false);
        const isLoading = ref(false);
        const isLoadingVehicleData = ref(false);
        const vehicleOptions = ref([]);
        const pendingLicencePlate = ref('');
        const showVehicleSelection = computed(() => !isLoadingVehicleData.value && vehicleOptions.value.length > 1);
        const numberPlateInputRef = ref(null);
        const canScroll = ref(false);
        const showBottomCue = ref(false);
        const containerCueClasses = computed(() => ({
            'license-plate-overlay__container--can-scroll': canScroll.value,
            'license-plate-overlay__container--show-bottom-cue': showBottomCue.value,
        }));
        const updateScrollCues = () => {
            const container = containerRef.value;
            if (!container)
                return;
            const tolerance = 2;
            const maxScrollTop = container.scrollHeight - container.clientHeight;
            const hasScrollableOverflow = maxScrollTop > tolerance;
            canScroll.value = hasScrollableOverflow;
            showBottomCue.value = hasScrollableOverflow && container.scrollTop < maxScrollTop - tolerance;
        };
        const emit = __emit;
        const open = async () => {
            isVisible.value = true;
            // Prevent body scroll when overlay is open
            document.body.style.overflow = 'hidden';
            // Wait for the DOM to update, then focus the input
            await nextTick();
            updateScrollCues();
            // Focus and select the input text for easy replacement
            numberPlateInputRef.value?.focusInput();
        };
        const closeOverlay = () => {
            isVisible.value = false;
            isLoading.value = false;
            isLoadingVehicleData.value = false;
            vehicleOptions.value = [];
            pendingLicencePlate.value = '';
            canScroll.value = false;
            showBottomCue.value = false;
            document.body.style.overflow = '';
            emit('close');
        };
        const handleSearchStart = (plate) => {
            pendingLicencePlate.value = plate;
            isLoading.value = true;
            vehicleOptions.value = [];
        };
        const handleSearchComplete = (results) => {
            isLoading.value = false;
            if (!results || results.length === 0) {
                // No results found - you might want to show an error message
                return;
            }
            if (results.length === 1) {
                // Single result - auto-select but don't close yet
                selectVehicle(results[0]);
            }
            else if (results.length > 1) {
                // Multiple results - show selection UI
                vehicleOptions.value = results;
            }
        };
        const selectVehicle = async (vehicle) => {
            // Show loading state
            isLoadingVehicleData.value = true;
            // Update vehicle details in the composable
            setVehicleDetails(vehicle);
            if (pendingLicencePlate.value) {
                setLicencePlate(pendingLicencePlate.value);
            }
            // Emit to parent so it can refresh products
            emit('vehicleSelected', vehicle);
            // Parent will handle the API call and data loading
            // The overlay will be closed by the parent after data is loaded
        };
        watch([showVehicleSelection, isLoadingVehicleData, isLoading], async () => {
            await nextTick();
            updateScrollCues();
        }, { flush: 'post' });
        // Expose methods to parent
        __expose({
            open,
            closeOverlay
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_Transition, { name: "overlay" }, {
                    default: _withCtx(() => [
                        (isVisible.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "license-plate-overlay",
                                onClick: _withModifiers(closeOverlay, ["self"])
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["license-plate-overlay__container", containerCueClasses.value])
                                }, [
                                    _cache[4] || (_cache[4] = _createElementVNode("div", {
                                        class: "license-plate-overlay__scroll-cue license-plate-overlay__scroll-cue--bottom",
                                        "aria-hidden": "true"
                                    }, null, -1)),
                                    _createElementVNode("button", {
                                        onClick: closeOverlay,
                                        class: "license-plate-overlay__close",
                                        "aria-label": "Close"
                                    }, [...(_cache[0] || (_cache[0] = [
                                            _createElementVNode("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg"
                                            }, [
                                                _createElementVNode("path", {
                                                    d: "M18 6L6 18M6 6L18 18",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round"
                                                })
                                            ], -1)
                                        ]))]),
                                    _createElementVNode("div", {
                                        ref_key: "containerRef",
                                        ref: containerRef,
                                        class: "license-plate-overlay__scroll-area",
                                        onScroll: updateScrollCues
                                    }, [
                                        _createElementVNode("div", _hoisted_1, [
                                            _createElementVNode("div", _hoisted_2, [
                                                _createElementVNode("div", _hoisted_3, [
                                                    _createElementVNode("img", {
                                                        src: _unref(assetUrl)('/images/trade-site/drop.svg'),
                                                        alt: ""
                                                    }, null, 8, _hoisted_4)
                                                ]),
                                                _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "license-plate-overlay__title" }, " Edit licence plate ", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_5, [
                                                _createVNode(NumberPlateInput, {
                                                    ref_key: "numberPlateInputRef",
                                                    ref: numberPlateInputRef,
                                                    "is-overlay": true,
                                                    onSearchStart: handleSearchStart,
                                                    onSearchComplete: handleSearchComplete
                                                }, null, 512)
                                            ])
                                        ]),
                                        (showVehicleSelection.value || isLoadingVehicleData.value || isLoading.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _createVNode(_Transition, { name: "fade" }, {
                                                    default: _withCtx(() => [
                                                        (isLoading.value || isLoadingVehicleData.value)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "spinner" }, null, -1)),
                                                                _createElementVNode("p", _hoisted_8, _toDisplayString(isLoadingVehicleData.value ? 'Loading vehicle recommendations...' : 'Searching for your vehicle...'), 1)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                }),
                                                (showVehicleSelection.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "license-plate-overlay__vehicles-title" }, "Select your vehicle", -1)),
                                                        _createElementVNode("div", _hoisted_10, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vehicleOptions.value, (vehicle) => {
                                                                return (_openBlock(), _createBlock(VehicleCard, {
                                                                    key: vehicle.id,
                                                                    type: vehicle,
                                                                    "compact-view": true,
                                                                    onSelect: ($event) => (selectVehicle(vehicle))
                                                                }, null, 8, ["type", "onSelect"]));
                                                            }), 128))
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 544)
                                ], 2)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
